import { GridColumnDataType } from '@infragistics/igniteui-angular';

import { GridColumnConfig } from './grid-column.config';

export class GridBooleanColumnConfig extends GridColumnConfig {
    trueText = 'General.Yes';
    falseText = 'General.No';
    isIcon = false;

    constructor(init?: Partial<GridBooleanColumnConfig>) {
        super(init);

        if (!!init) {
            Object.assign(this, init);
        }

        this.dataType = GridColumnDataType.Boolean;
    }
}
